<div>
  <app-header-layout></app-header-layout>
  <router-outlet></router-outlet>
  <app-footer-layout></app-footer-layout>
</div>
